function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b848c2e0-e1e4-4bf9-b37e-190bfa39bd27",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "af8f6c52-8f7c-4b38-9926-2d816f720d8f",
    "data-name": "Wave-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bd1d2bb0-d2d9-4fec-a3c7-3a2b970a9469",
    "data-name": "Rectangle",
    d: "M1366,48C743,48,699-9.89532,0,1.48108V48Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave8;